import {StackableError} from "@musicdata/common/src/StackableError";

export class MeasurementUnit {

    private readonly _alias : EMeasurementUnitAlias

    public constructor(alias : EMeasurementUnitAlias) {
        this._alias = alias ?? EMeasurementUnitAlias.ks;
    }

    public get alias() : EMeasurementUnitAlias {
        return this._alias;
    }

    public get text() : string {
        return this._alias;
    }

    public get html() : string {

        switch (this._alias) {
            case EMeasurementUnitAlias.ks : return "ks";
            case EMeasurementUnitAlias.l : return "l";
            case EMeasurementUnitAlias.m : return "m";
            case EMeasurementUnitAlias.m2 : return "m<sup>2</sup>";
            case EMeasurementUnitAlias.m3 : return "m<sup>3</sup>";
            default : throw new StackableError("Measurement unit is not implemented", {alias : this._alias});
        }
    }
}

export enum EMeasurementUnitAlias {
    ks = "ks",
    l = "l",
    m = "m",
    m2 = "m2",
    m3 = "m3",
}